import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';

import * as contentEn from '../assets/i18n/en.json';
import * as contentEnGB from '../assets/i18n/en-GB.json';
import * as contentDe from '../assets/i18n/de.json';
import * as contentFr from '../assets/i18n/fr.json';
import * as contentEs from '../assets/i18n/es.json';
import * as contentIt from '../assets/i18n/it.json';
import * as contentNl from '../assets/i18n/nl.json';
import * as contentPt from '../assets/i18n/pt_PT.json';
import * as clContentEn from '../assets/cl-console-components/i18n/en.json';
import * as clContentEnGB from '../assets/cl-console-components/i18n/en-GB.json';
import * as clContentDe from '../assets/cl-console-components/i18n/de.json';
import * as clContentFr from '../assets/cl-console-components/i18n/fr.json';
import * as clContentEs from '../assets/cl-console-components/i18n/es.json';
import * as clContentIt from '../assets/cl-console-components/i18n/it.json';
import * as clContentNl from '../assets/cl-console-components/i18n/nl.json';
import * as clContentPt from '../assets/cl-console-components/i18n/pt_PT.json';
import * as miccbContentEn from '@mitel-internal/miccb-components/src/assets/i18n/en.json';
import * as miccbContentEnGB from '@mitel-internal/miccb-components/src/assets/i18n/en-GB.json';
import * as miccbContentDe from '@mitel-internal/miccb-components/src/assets/i18n/de.json';
import * as miccbContentFr from '@mitel-internal/miccb-components/src/assets/i18n/fr.json';
import * as miccbContentEs from '@mitel-internal/miccb-components/src/assets/i18n/es.json';
import * as miccbContentIt from '@mitel-internal/miccb-components/src/assets/i18n/it.json';
import * as miccbContentNl from '@mitel-internal/miccb-components/src/assets/i18n/nl.json';
import * as miccbContentPt from '@mitel-internal/miccb-components/src/assets/i18n/pt_PT.json';
import * as mivbContentEn from '@mitel-internal/mivb-components/src/assets/i18n/en.json';
import * as mivbContentEnGB from '@mitel-internal/mivb-components/src/assets/i18n/en-GB.json';
import * as mivbContentDe from '@mitel-internal/mivb-components/src/assets/i18n/de.json';
import * as mivbContentFr from '@mitel-internal/mivb-components/src/assets/i18n/fr.json';
import * as mivbContentEs from '@mitel-internal/mivb-components/src/assets/i18n/es.json';
import * as mivbContentIt from '@mitel-internal/mivb-components/src/assets/i18n/it.json';
import * as mivbContentNl from '@mitel-internal/mivb-components/src/assets/i18n/nl.json';
import * as mivbContentPt from '@mitel-internal/mivb-components/src/assets/i18n/pt_PT.json';
import * as catContentEn from '../assets/cl-catalogue/en.json';
import * as catContentEnGB from '../assets/cl-catalogue/en-GB.json';
import * as catContentDe from '../assets/cl-catalogue/de-DE.json';
import * as catContentFr from '../assets/cl-catalogue/fr-FR.json';
import * as catContentEs from '../assets/cl-catalogue/es-ES.json';
import * as catContentIt from '../assets/cl-catalogue/it-IT.json';
import * as catContentNl from '../assets/cl-catalogue/nl.json';
import * as catContentPt from '../assets/cl-catalogue/pt-PT.json';

const TRANSLATIONS = {
	en: {...contentEn["default"], ...clContentEn["default"], ...mivbContentEn["default"], ...miccbContentEn["default"],...catContentEn["default"]},
	'en-GB': {...contentEnGB["default"], ...clContentEnGB["default"], ...mivbContentEnGB["default"], ...miccbContentEnGB["default"], ...catContentEnGB["default"]},
	de: {...contentDe["default"], ...clContentDe["default"], ...mivbContentDe["default"], ...miccbContentDe["default"], ...catContentDe["default"]},
	fr: {...contentFr["default"], ...clContentFr["default"], ...mivbContentFr["default"], ...miccbContentFr["default"], ...catContentFr["default"]},
	es: {...contentEs["default"], ...clContentEs["default"], ...mivbContentEs["default"], ...miccbContentEs["default"], ...catContentEs["default"]},
	it: {...contentIt["default"], ...clContentIt["default"], ...mivbContentIt["default"], ...miccbContentIt["default"], ...catContentIt["default"]},
	nl: {...contentNl["default"], ...clContentNl["default"], ...mivbContentNl["default"], ...miccbContentNl["default"], ...catContentNl["default"]},
	pt: {...contentPt["default"], ...clContentPt["default"], ...mivbContentPt["default"], ...miccbContentPt["default"], ...catContentPt["default"]}
};

export class WebpackTranslateLoader implements TranslateLoader {
	getTranslation(lang: string): Observable<any> {
		return of(TRANSLATIONS[lang]);
	}
}
